(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["crucifix-turntable"] && !Shopify.designMode) return;
  try {
    (()=>{
function init(scope){
scope.querySelectorAll('.crucifix-turntable:not([data-ready])').forEach(root=>{
root.dataset.ready='true';
const video=root.querySelector('video'),button=root.querySelector('button');
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
let paused=reduced.matches||Boolean(navigator.connection?.saveData),visible=false;
function updateControl(playing){
button.dataset.state=playing?'playing':'paused';
button.setAttribute('aria-label',playing?'Pause product rotation':'Play product rotation');
}
function load(){
if(video.getAttribute('src'))return;
video.muted=true;video.preload='auto';video.src=video.dataset.turntableSrc;
}
function sync(){
if(visible&&!paused&&!document.hidden){
load();
video.play().catch(()=>updateControl(false));
}else video.pause();
}
video.addEventListener('playing',()=>{root.classList.add('is-ready');updateControl(true);});
video.addEventListener('pause',()=>updateControl(false));
video.addEventListener('error',()=>{root.classList.remove('is-ready');button.hidden=true;});
button.addEventListener('click',()=>{paused=!video.paused;if(!paused)visible=true;sync();});
reduced.addEventListener('change',()=>{paused=reduced.matches;sync();});
document.addEventListener('visibilitychange',sync);
const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.15});observer.observe(root);
const preloader=new IntersectionObserver(entries=>{
if(entries[0].isIntersecting&&!paused&&!document.hidden){load();preloader.disconnect();}
},{rootMargin:'300px 0px'});preloader.observe(root);
});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
document.addEventListener('shopify:section:load',e=>init(e.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nf-best-sellers-page"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(root){
    var pages=(root||document).querySelectorAll('[data-nf-bestsellers]');
    pages.forEach(function(page){
      if(page.dataset.nfbsReady)return;
      page.dataset.nfbsReady='true';
      var filters=page.querySelector('.nfbs__filters');
      var buttons=page.querySelectorAll('[data-nfbs-filter]');
      var cards=Array.from(page.querySelectorAll('.nfbs__card'));
      var count=page.querySelector('[data-nfbs-count]');
      var empty=page.querySelector('.nfbs__empty');
      if(filters)filters.hidden=false;
      buttons.forEach(function(button){
        button.addEventListener('click',function(){
          var group=button.dataset.nfbsFilter,visible=0;
          buttons.forEach(function(item){item.setAttribute('aria-pressed',String(item===button));});
          cards.forEach(function(card){var show=group==='all'||card.dataset.nfbsGroups.split(/\s+/).includes(group);card.hidden=!show;if(show)visible++;});
          if(count)count.textContent=String(visible);
          if(empty)empty.hidden=visible!==0;
        });
      });
      var select=page.querySelector('[name="sort_by"]');
      if(select)select.addEventListener('change',function(){select.form.requestSubmit();});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nf-resurrection-product-nav"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.nfResurrectionMotion) return;
  window.nfResurrectionMotion = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const active = new WeakMap();
  function strike(element, frames, duration) {
    if (!element || !element.animate) return;
    active.get(element)?.cancel();
    const motion = element.animate(frames, { duration, easing: 'cubic-bezier(.16,.85,.25,1)' });
    active.set(element, motion);
  }
  document.addEventListener('click', (event) => {
    if (reduced.matches || !(event.target instanceof Element)) return;
    const control = event.target.closest('.nf-rp-identity__nav a, .product-form button[type="submit"], .opt-label, .pack__block, .thumbnail, .nf-crucifix-facts summary, .nf-crucifix-dossier summary, #corner-sticky-atc-cta-button');
    if (!control || control.matches(':disabled, [aria-disabled="true"]')) return;
    const root = document.querySelector('#content.nf-rp');
    if (!root || (!root.contains(control) && control.id !== 'corner-sticky-atc-cta-button')) return;
    active.get(control)?.cancel();
    const base = getComputedStyle(control).transform;
    const transform = base === 'none' ? '' : base;
    strike(control, [
      { transform: transform + ' scale(.96) translateY(2px)' },
      { transform: transform + ' scale(1.012) translateY(-1px)', offset: .48 },
      { transform: transform + ' scale(1) translateY(0)' }
    ], 260);
  }, true);
})();

(() => {
  const reviewIcon = '<svg class="nf-review-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 11v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h8"/><path d="m16 3 3-2 3 3-2 3-9 9-4 1 1-4Z"/></svg>';
  function init() {
    const root = document.querySelector('#content.nf-rp');
    if (!root || root.dataset.nfReviewInvite) return;
    root.dataset.nfReviewInvite = 'true';
    function update() {
      root.querySelectorAll('.jdgm-write-rev-link').forEach((button) => {
        const open = button.getAttribute('aria-expanded') === 'true';
        const label = open ? 'Close Review Form' : 'Tell Us How It Hit';
        if (button.textContent.trim() !== label || !button.querySelector('.nf-review-icon')) {
          button.innerHTML = reviewIcon + '<span>' + label + '</span>';
          button.setAttribute('aria-label', open ? 'Close review form' : 'Write a review: tell us how it hit');
        }
      });
    }
    update();
    new MutationObserver(update).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-expanded'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

(() => {
  function init() {
    const root = document.querySelector('#content.nf-rp');
    const data = root?.querySelector('.product-detail [data-product-json]');
    if (!data || root.dataset.nfStockReady) return;
    const product = JSON.parse(data.textContent);
    const detail = data.closest('.product-detail');
    const status = detail.querySelector('.nf-rp-stock-status');
    if (!status) return;
    root.dataset.nfStockReady = 'true';
    const sold = status.dataset.soldOut;
    const inStock = status.dataset.inStock;
    const unavailable = status.dataset.unavailable;
    let queued = false;
    const selectedValues = () => product.options.map((_, index) => {
      const group = detail.querySelector('.option-selector[data-option-index="' + index + '"]');
      return group?.querySelector('input:checked')?.value || group?.querySelector('.cc-select__option[aria-selected="true"]')?.dataset.value;
    });
    function sync() {
      queued = false;
      const values = selectedValues();
      detail.querySelectorAll('.option-selector .opt-btn').forEach(input => {
        const index = Number(input.closest('[data-option-index]').dataset.optionIndex);
        const available = product.variants.some(v => v.available && v.options[index] === input.value && v.options.every((value, i) => i >= index || !values[i] || value === values[i]));
        input.disabled = !available;
        input.setAttribute('aria-disabled', String(!available));
        input.setAttribute('aria-label', input.value + (available ? '' : ' — ' + sold));
        const label = input.nextElementSibling;
        if (label) label.title = available ? input.value : input.value + ' — ' + sold;
      });
      const id = detail.querySelector('select[name="id"]')?.value || detail.querySelector('input[name="id"]')?.value;
      const variant = product.variants.find(v => String(v.id) === id);
      const text = (variant && !product.has_only_default_variant && variant.title !== 'Default Title' ? variant.title + ' — ' : '') + (variant ? variant.available ? inStock : sold : unavailable);
      if (status.textContent !== text) status.textContent = text;
      status.dataset.available = String(Boolean(variant?.available));
            detail.querySelectorAll('.product-form button[type="submit"]').forEach(button => {
        if (!variant?.available) { button.disabled = true; button.dataset.nfStockDisabled = 'true'; }
        else if (button.dataset.nfStockDisabled) { button.disabled = false; delete button.dataset.nfStockDisabled; }
      });
      const sticky = document.querySelector('#corner-sticky-atc-outer-container');
      if (!sticky) return;
      const selects = [...sticky.querySelectorAll('#corner-sticky-atc-variant_selection select')];
      selects.forEach((select, index) => [...select.options].forEach(option => {
        if (option.value === 'true') return;
        const available = product.variants.some(v => v.available && v.options[index] === option.value && v.options.every((value, i) => i >= index || value === selects[i]?.value));
        option.disabled = !available;
        const label = option.value + (available ? '' : ' — ' + sold);
        if (option.textContent !== label) option.textContent = label;
      }));
      const stickyVariant = product.variants.find(v => selects.length ? v.options.every((value, i) => value === selects[i]?.value) : String(v.id) === sticky.querySelector('[data-corner-variant-id]')?.dataset.cornerVariantId);
      const button = sticky.querySelector('#corner-sticky-atc-cta-button');
            if (button && stickyVariant) {
        if (!stickyVariant.available) { button.disabled = true; button.dataset.nfStockDisabled = 'true'; }
        else if (button.dataset.nfStockDisabled) { button.disabled = false; delete button.dataset.nfStockDisabled; }
      }
      const name = sticky.querySelector('#corner-sticky_atc-product_name');
      const title = detail.querySelector('.title')?.textContent.trim();
      if (name && title && name.textContent !== title) name.textContent = title;
    }
    function schedule() { if (!queued) { queued = true; requestAnimationFrame(sync); } }
        document.addEventListener('change', event => {
      if (event.target.matches?.('#corner-sticky-atc-variant_selection select')) {
        const selects = [...document.querySelectorAll('#corner-sticky-atc-variant_selection select')];
        const index = selects.indexOf(event.target);
        const group = detail.querySelector('.option-selector[data-option-index="' + index + '"]');
        const input = [...(group?.querySelectorAll('.opt-btn') || [])].find(input => input.value === event.target.value);
        if (input && !input.disabled && !input.checked) input.click();
      }
      schedule();
    });
    const picker = detail.querySelector('.option-selectors');
    if (picker) new MutationObserver(schedule).observe(picker, {subtree:true,attributes:true,attributeFilter:['class']});
    new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['data-corner-variant-id']});
    document.addEventListener('click', event => {
      const button = event.target.closest?.('#corner-sticky-atc-cta-button');
      if (button?.disabled) { event.preventDefault(); event.stopImmediatePropagation(); }
    }, true);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

})();
